import { createRoute, Link, useParams } from '@tanstack/react-router';
import { useRipple } from '@/hooks/use-ripple.ts';
import { layoutRoute } from '@/router/root-routes.tsx';
import { setAuthAction, setShowAuth } from '@/stores/auth.store.ts';
import { useEffect } from 'react';

export const homeRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: '/',
  component: HomeLoginPage,
});

export const loginRoute = createRoute({
  getParentRoute: () => layoutRoute,
  path: 'login/$',
  component: HomeLoginPage,
});

export function HomeLoginPage() {
  const { ref } = useRipple();
  const params = useParams({ strict: false });
  useEffect(() => {
    if (params._splat !== undefined) {
      if (params._splat === 'reset_password') {
        setAuthAction('reset-password');
      }
      setShowAuth(true);
    }
  }, [params]);

  return (
    <>
      <video
        autoPlay
        muted
        loop
        width="1280"
        height="720"
        playsInline
        poster="/media/home/poster.png"
        src="https://sacco-public.s3.us-east-1.amazonaws.com/Sacco-Video-Header-V2-2025-05-31.mp4"
        className="w-full h-auto block mx-auto"
      ></video>
      <div ref={ref as any} className="max-w-8xl mx-auto">
        <p className="text-xl max-w-7xl mx-auto text-center px-4 py-8 md:py-16">
          <span className="uppercase text-xl">Sacco Carpet</span> produces the highest quality carpets for the world’s
          leading interior designers and architects. To meet expectations, we have the most talented artists in the
          industry and never sacrificed quality for price. We take every detail into consideration, focusing on quality,
          color, price effectiveness and longevity.
        </p>
        <div className="grid md:grid-cols-2 gap-4">
          <CollectionTile
            to="/installations-residential"
            title="Residential Collection"
            src="/media/home/collections-residential.jpeg"
          />
          <CollectionTile
            to="/installations-hospitality"
            title="Hospitality Collection"
            src="/media/home/collections-hospitality.jpeg"
          />
        </div>
        <div className="py-8 md:py-16">
          <h3 className="text-center">NEW ARRIVALS</h3>
        </div>
      </div>
    </>
  );
}

type CollectionTileProps = {
  to: any;
  title: string;
  src: string;
};
const CollectionTile = ({ to, title, src }: CollectionTileProps) => {
  return (
    <Link to={to} viewTransition={true} className="ripple">
      <div className="tile relative overflow-hidden group">
        <img
          alt={title}
          src={src}
          className="transition-transform duration-4000 transform group-hover:scale-110 peer ease-in-out"
        />
        <h2 className="absolute text-nowrap top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-white uppercase px-2 py-1 text-lg font-normal bg-gray-600/50 group-hover:bg-gray-950/50 transition-all duration-500">
          {title}
        </h2>
      </div>
    </Link>
  );
};
